import { AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { TradeSuccessComponent } from "@modules/main/components/step-summary/success-screens/trade-success/trade-success.component";
import { AnimationOptions } from "ngx-lottie";
import { Router } from "@angular/router";
import { AccountService } from "@modules/account/services/account.service";
import { FiatService } from "@main-services/currency";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { SegmentService } from "@main-services/segment.service";
import { SharePreviewComponent } from "@modules/social-trading/components/share-preview/share-preview.component";
import { TRADE_LOCAKEY } from "@modules/social-trading/components/share-preview/share-preview.constants";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { RudderstackService } from "@main-services/rudderstack.service";

@Component({
	selector: "trade-success-v1",
	templateUrl: "./trade-success-redesign.component.html",
	styleUrls: ["./../../success-screen.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class TradeSuccessV1Component extends TradeSuccessComponent implements AfterViewChecked {
	public constructor(
		protected router: Router,
		protected fiatService: FiatService,
		protected accountService: AccountService,
		protected tradableListService: TradableListService,
		protected segmentService: SegmentService,
		protected rudderstackService: RudderstackService,
		protected walletListService: TradableWalletListService,
		private cdRef: ChangeDetectorRef
	) {
		super(
			router,
			fiatService,
			accountService,
			tradableListService,
			segmentService,
			rudderstackService,
			walletListService
		);
	}

	public ngAfterViewChecked(): void {
		this.cdRef.detectChanges();
	}

	public successAnimationOptions: AnimationOptions = {
		path: "assets/animations/trade_success_animation.json",
		loop: false
	};

	public shareTrade(): void {
		const assetId = this.offer.getCurrencyId();
		const tradeType = this.offer.getType();
		this.modalService.create(SharePreviewComponent, { assetId, tradeType, locaKey: TRADE_LOCAKEY }).present();
	}
}
